interface SaveStateInlineProps {
  isSubmitting: boolean;
  isValid: boolean;
  isDirty: boolean;
  isAutoSaving?: boolean;
  isAutoSavePending?: boolean;
  autoSaveErrorMessage?: string | null;
}

export function SaveStateInline({
  isSubmitting,
  isValid,
  isDirty,
  isAutoSaving = false,
  isAutoSavePending = false,
  autoSaveErrorMessage = null,
}: SaveStateInlineProps) {
  if (isSubmitting || isAutoSaving) {
    return (
      <p className="font-inter text-sm text-neutral-500">
        <i className="fa-solid fa-spinner fa-spin mr-2" />
        Saving...
      </p>
    );
  }

  if (autoSaveErrorMessage) {
    return (
      <p className="font-inter text-sm text-red-600">
        <i className="fa-solid fa-circle-exclamation mr-2" />
        Auto-save failed. {autoSaveErrorMessage}
      </p>
    );
  }

  if (!isValid) {
    return (
      <p className="font-inter text-sm text-red-600">
        <i className="fa-solid fa-circle-exclamation mr-2" />
        Cannot save with invalid input.
      </p>
    );
  }

  if (isAutoSavePending || isDirty) {
    return (
      <p className="font-inter text-sm text-neutral-500">
        Pending auto-save...
      </p>
    );
  }

  return (
    <p className="font-inter text-sm text-green-600">
      <i className="fa-solid fa-circle-check mr-2" />
      All changes saved.
    </p>
  );
}
